import { QueryClient, QueryKey, QueryCache } from "react-query";
import { refetchMonitor } from "./refetchMonitor";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ICacheQueryData<T extends Array<any>> = (
  ...queries: IQueries<T>
) => void;

export type IQuery<Type> = {
  key: QueryKey;
  value: Type;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IQueries<Types extends Array<any>> = IQuery<Types[number]>[];

const init = (): QueryClient => {
  // Create QueryCache with ASYNCHRONOUS monitoring
  // IMPORTANT: The callback must use queueMicrotask or setTimeout to avoid blocking
  // React Query's internal observer notification mechanism
  const queryCache = new QueryCache({
    onSuccess: (_data, query) => {
      // Use queueMicrotask to schedule monitoring AFTER current execution context
      // This ensures React Query's observer notifications complete first
      queueMicrotask(() => {
        refetchMonitor.recordRefetch(query.queryKey);
      });
    },
  });

  const client = new QueryClient({
    queryCache,
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return client;
};

export const dataLayer = init();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cacheQueryData: ICacheQueryData<any[]> = (...queries) => {
  Object.keys(queries).forEach((key) => {
    dataLayer.setQueryData(queries[key].key, queries[key].value);
  });
};
